<template>
  <div class="content">
    <div class="row">
      <div class="col-md-8">
        <div class="card" v-if="clientProfile !=null">
          <div class="card-header" style="width: 100%">
            <div style="width: 50%">
              <h5 class="card-title" style="float:left;">{{clientProfile.businessName}}</h5>
            </div>
            <div class="col-md-4 ml-auto" style="text-align:right;">
              <p-button
                @click="$router.push('/client/update/'+clientProfile._id)"
                link
                type="info"
                style="margin-left:10px;"
              >
                <i class="fa fa-pen"></i> Edit
              </p-button>
            </div>
          </div>
          <div class="card-body">
            <div class="typography-line">
              <p>
                <span>Business Name</span>
                {{clientProfile.businessName}}
              </p>
            </div>
            <div class="typography-line">
              <p>
                <span>Instagram Profile</span>
                @{{clientProfile.instagramProfile}}
              </p>
            </div>
            <div class="typography-line" v-if="clientProfile.website">
              <p>
                <span>website</span>
                <a :href="clientProfile.website" target="_blank">{{clientProfile.website}}</a>
              </p>
            </div>
            <div class="typography-line" v-if="clientProfile.address1">
              <p>
                <span>Address 1</span>
                {{clientProfile.address1}}
              </p>
            </div>
            <div class="typography-line" v-if="clientProfile.address2">
              <p>
                <span>Addess 2</span>
                {{clientProfile.address1}}
              </p>
            </div>
             <div class="typography-line" v-if="clientProfile.city">
              <p>
                <span>City</span>
                {{clientProfile.city}}
              </p>
            </div>
             <div class="typography-line" v-if="clientProfile.state">
              <p>
                <span>State</span>
                {{clientProfile.state}}
              </p>
            </div>
             <div class="typography-line" v-if="clientProfile.country">
              <p>
                <span>Country</span>
                {{clientProfile.country}}
              </p>
            </div>
          </div>
        </div>
        <div>
          <p-button
            @click="$router.push('/client/update/'+clientProfile._id)"
            round
            outline
            type="info"
            style="margin-left:10px;"
          >Edit Client</p-button>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card">
          <div class="card-header" style="width: 100%">
            <h5 class="card-title">Team</h5>
          </div>
          <div class="card-body">
            <div v-if="clientMembersActive.length > 0">
              <div v-for="member in clientMembersActive" :key="member._id">
                <div
                  v-if="typeof member.firstName !=='undefined'"
                >{{member.firstName}} {{member.lastName}}</div>
                <div v-else>{{member.email}}</div>
              </div>
              <hr />
            </div>

            <div v-if="clientMembersInvited.length > 0">
              <el-table :data="clientMembersInvited">
                <el-table-column label="Invited">
                  <template slot-scope="props">
                    <div style="font-size:12px;">{{props.row.email}}</div>
                  </template>
                </el-table-column>
                <el-table-column label>
                  <template slot-scope="props">
                    <el-tooltip content="resend invite" :open-delay="300" placement="right">
                      <p-button
                        round
                        outline
                        type="success"
                        size="sm"
                        @click="clientResendInvite(props.row._id)"
                      >
                        <i class="fa fa-envelope"></i>
                      </p-button>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
              <hr />
            </div>
            <div>
              <h6>Invite Team</h6>
              <fg-input
                label="Email"
                v-model="model.inviteEmail"
                v-validate="modelValidations.inviteEmail"
                name="inviteEmail"
                type="text"
                :error="getError('inviteEmail')"
                required
              ></fg-input>

              <p-button
                small
                round
                outline
                size="sm"
                @click="createClientInvite"
                type="info"
              >Send Invite</p-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--  <v-content>
    <v-overlay v-if="loadingOverlay === true">
      <div>Loading Page...</div>
    </v-overlay>

   

    <v-container v-if="clientProfile !== null">
      <v-row>
        <v-col cols="12" md="8">
          <v-card>
            <v-container>
              <div class="text--primary">{{clientProfile.businessName}}</div>
              <div class="text--primary">@{{clientProfile.instagramProfile}}</div>
              <div class="text--primary">{{clientProfile.address1}}</div>
              <div class="text--primary">{{clientProfile.address2}}</div>
            </v-container>
          </v-card>
        </v-col>
        <v-col cols="12" md="4">
          <v-card>
            <v-card-title>Client Members:</v-card-title>
            <v-list v-if="clientMembersActive !== null">
              <v-list-item v-for="member in clientMembersActive" :key="member._id">
                <div
                  v-if="typeof member.firstName !=='undefined'"
                >{{member.firstName}} {{member.lastName}}</div>
                <div v-else>{{member.email}}</div>
              </v-list-item>
            </v-list>
          </v-card>
          <v-card>
            <v-card-title>Pending Invites:</v-card-title>

            <v-simple-table v-if="clientMembersInvited !== null">
              <tbody>
                <tr v-for="invited in clientMembersInvited" :key="invited._id">
                  <td>{{invited.email}}</td>
                  <td>
                    <v-btn
                      text
                      small
                      color="success"
                      @click="clientResendInvite(invited._id)"
                      primary
                    >RESEND INVITE</v-btn>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
            <v-container>
              Invite Team
              <v-text-field label="Email Address" outlined v-model="inviteEmail" dense required></v-text-field>
              <v-btn small depressed color="success" @click="createClientInvite">Send Invite</v-btn>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-content>-->
</template>
<script>
import firebase from "firebase";
import axios from "axios";
import {
  clientProfileReadApi,
  clientInviteCreateApi,
  clientMembersApi,
  clientInviteResendApi
} from "@/config/appSettings";
import { Tooltip } from "element-ui";
export default {
  data: () => ({
    auth: null,
    loadingOverlay: false,
    clientProfile: null,
    inviteEmail: null,
    clientInvites: null,
    clientMembers: null,
    clientMembersInvited: [],
    clientMembersActive: [],
    businessName: null,
    model: {
      inviteEmail: ""
    },
    modelValidations: {
      inviteEmail: {
        required: true,
        email: true
      }
    }
  }),
  name: "ClientDetail",
  components: {
    [Tooltip.name]: Tooltip
  },
  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      this.$validator.validateAll().then(isValid => {
        try {
          //console.log("CHECKING IS VALID:", isValid);
          //console.log("CHECKING REGISTER FORM: ", this.registerForm);
          this.$emit("on-submit", this.registerForm, isValid);
        } catch (err) {
          //console.log("THERE WAS AN ERROR:", err);
        }
      });
    },
    async loadClientProfile() {
      try {
        let clientProfileResponse = await axios.get(
          `${clientProfileReadApi}/?usertoken=${this.auth}&client=${this.$route.params.clientId}`
        );

        if (clientProfileResponse.data.success === true) {
          //console.log("CLIENT PROFILE:", clientProfileResponse.data.result[0]);
          this.clientProfile = clientProfileResponse.data.result[0];
        }
      } catch (err) {}
    },
    async loadClientMembers() {
      try {
        let clientMembersResponse = await axios.get(
          `${clientMembersApi}/?usertoken=${this.auth}&client=${this.$route.params.clientId}`
        );
        //console.log("CLIENT MEMBERS:", clientMembersResponse.data);
        if (clientMembersResponse.data.success === true) {
          this.clientMembersActive = clientMembersResponse.data.result.members;
          this.clientMembersInvited = clientMembersResponse.data.result.invites;
          // this.clientProfile = clientProfileResponse.data.result[0];
        }
      } catch (err) {}
    },
    async clientResendInvite(inviteId) {
      try {
        let clientInviteResendResponse = await axios.get(
          `${clientInviteResendApi}/?usertoken=${this.auth}&invite=${inviteId}`
        );
        //console.log("CLIENT MEMBERS:", clientInviteResendResponse.data);
        if (clientInviteResendResponse.data.success === true) {
          // this.clientProfile = clientProfileResponse.data.result[0];
        }
      } catch (err) {}
    },
    async createClientInvite() {
      try {
        if ((await this.$validator.validateAll()) === true) {
          let newClientInvite = {};
          newClientInvite.email = this.model.inviteEmail;
          newClientInvite.usertoken = this.auth;
          newClientInvite.client = this.$route.params.clientId;

          let clientInviteResponse = await axios.post(
            clientInviteCreateApi,
            newClientInvite
          );

          if (clientInviteResponse.data.success === true) {
            this.loadClientMembers();
            
            this.modelValidations.inviteEmail
            /*console.log(
              "CLIENT INVITE RESPONSE:",
              clientInviteResponse.data.result[0]
            );*/
          }
        }
      } catch (err) {}
    }
  },

  mounted() {
    this.auth = firebase.auth().currentUser.uid;
    this.loadClientProfile();
    this.loadClientMembers();
  }
};
</script>

<style scoped>
</style>